import { bunja, createScope } from 'bunja';
import { useBunja } from 'bunja/react';

const ClassNameScope = createScope<string>();
const IsShowScope = createScope<boolean>();

const bodyClassBunja = bunja(() => {
  const className = bunja.use(ClassNameScope);
  const isShow = bunja.use(IsShowScope);

  bunja.effect(() => {
    if (!isShow) return () => {};
    document.body.classList.add(className);
    return () => document.body.classList.remove(className);
  });

  return {};
});
bodyClassBunja.debugLabel = 'bodyClassBunja';

export function useBodyClass(className: string, isShow: boolean): void {
  useBunja(bodyClassBunja, [ClassNameScope.bind(className), IsShowScope.bind(isShow)]);
}
